<template>
  <div class="Comment-Last" @click="goToComment">
    <AvatarImage class="Comment-Last__img" :src="get_commentAvatar" :size="20" />
    <p class="Comment-Last__txt" v-html="get_commentTxt || 'Изображение'"></p>
    <CounterComment
      class="Comment-Last__counter"
      :count="get_post.init_comments_count"
      :newCommentsCounter="get_post.comments_count"
    />
  </div>
</template>

<script setup>
  import { computed, nextTick } from 'vue';
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  //---------------------------------------
  import AvatarImage from '@ui/Images/AvatarImage/AvatarImage.vue';
  import CounterComment from '@ui/Counters/CounterComment/CounterComment.vue';
  //---------------------------------------
  const props = defineProps(Props());
  const store = useStore();
  const route = useRoute();
  //---------------------------------------
  const ID = props.postId;
  const COMMENT_CTX = 'popupComments';
  //--------------------------------------
  //Получить объект поста
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[ID] || store.state.ContentSystem.Infonoise.list[ID]);
  //Получить объект последнего комментария
  const get_lastComment = computed(() => get_post.value?.last_comment)
  //Получить аватар ползователя последнего комментария
  const get_commentAvatar = computed(() => get_lastComment.value?.user.avatar);
  //Получить текст последнего комментария
  const get_commentTxt = computed(() => get_lastComment.value?.comment);
  //Получить адрес перехода
  const get_routeUrl = computed(() => `/${get_post.value.model_name.toLowerCase()}/${get_post.value.id}`);
  //---------------------------------------
  //Переместиться к комментарию
  const goToComment = async () => {
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.contentPage);
    await nextTick();
    toChangeUrl();
    store.commit('ContentSystem/Comments/setScrollTarget', {
      isComments: true,
      idComment: get_lastComment.value.id,
      context: COMMENT_CTX
    });
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.contentPage);
  }
  //Обновить адрес в строке поиска и запомнить последний урл перед переходом
  const toChangeUrl = () => {
    store.commit('ContentSystem/toRememberLastPageUrl', route.path);
    window.history.pushState({}, '', window.location.href);
    window.history.replaceState({}, '', get_routeUrl.value);
  };
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>
